import { styled } from '@mui/material';
import { colorPalettes } from '../../../context/theme';

export const StyledCard = styled('div')`
  box-sizing: border-box;
  padding: 0.58rem 1rem;
  border-radius: 0.92rem;
  background: ${({ theme }) =>
    colorPalettes[theme.palette.mode].card.background.primary};
  border: 0.5px solid
    ${({ theme }) => colorPalettes[theme.palette.mode].card.border.primary};

  &:hover {
    background: ${({ theme }) =>
      colorPalettes[theme.palette.mode].card.background.hover};
    border: 0.5px solid
      ${({ theme }) =>
        colorPalettes[theme.palette.mode].card.border.hover.color};
    box-shadow: 4px 4px 34px 0px
      ${({ theme }) =>
        colorPalettes[theme.palette.mode].card.border.hover.shadow};
  }
`;
